import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;

export const getFlightBookings = async (params) => {
  const { data } = await axios.get(`${API_URL}/admin/bookings/flight`, {
    withCredentials: true,
    params,
  });
  return data;
};

export const getFlightBookingsSummary = async () => {
  const { data } = await axios.get(
    `${API_URL}/admin/bookings/flight/summary`,
    { withCredentials: true },
  );
  return data;
};

export const searchFlightBookings = async (searchText, type) => {
  const { data } = await axios.post(
    `${API_URL}/admin/bookings/search`,
    { searchText: searchText.trim() },
    { withCredentials: true, params: { type } },
  );
  return data;
};

// Throws with err.response.data intact ({ code, error, cancellation? } on
// 409, { code, error, provider, providerErrors } on 502) so the modal can
// render the specific failure instead of a generic message.
export const cancelBooking = async (bookingId, payload) => {
  const { data } = await axios.patch(
    `${API_URL}/admin/bookings/${bookingId}/cancel`,
    payload,
    { withCredentials: true },
  );
  return data;
};

export const manuallyIssueTicket = async (payload) => {
  const { data } = await axios.post(`${API_URL}/manual-issuance`, payload, {
    withCredentials: true,
  });
  return data;
};
